import { Loader2 } from 'lucide-react';

export function PageLoadingFallback() {
  return (
    <div
      className="flex min-h-[100dvh] min-h-screen flex-col items-center justify-center gap-4 bg-background px-4"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <Loader2 className="h-10 w-10 animate-spin text-primary" aria-hidden />
      <p className="text-sm font-medium text-muted-foreground">A carregar…</p>
    </div>
  );
}
